const objectivesMap = {
	'Pérdida de grasa': 'Reducir grasa corporal.',
	'Ganancia de masa muscular': 'Aumentar músculo.',
	Mantenimiento: 'Mantener condición física.',
	'Mejora del rendimiento': 'Optimizar fuerza y resistencia.',
	Recuperación: 'Acelerar recuperación física.',
	'Salud general': 'Mejorar bienestar integral.',
	'Definición muscular': 'Resaltar masa muscular.',
	'Acondicionamiento físico': 'Mejorar forma física general.',
	'Aumento de energía': 'Incrementar vitalidad diaria.',
	'Preparación deportiva': 'Listo para una competencia.',
	'Movilidad y flexibilidad': 'Mejorar rango de movimiento.',
	'Resistencia cardiovascular': 'Aumentar capacidad aeróbica.',
	'Control de peso': 'Mantener peso saludable.',
	Rehabilitación: 'Recuperarse de lesiones.',
	'Bienestar mental': 'Reducir estrés y mejorar ánimo.',
	'Fuerza explosiva': 'Incrementar potencia muscular.',
	'Resistencia muscular': 'Aumentar duración del esfuerzo.',
	'Postura y alineación': 'Corregir y prevenir dolencias.',
	'Entrenamiento funcional': 'Mejorar movimientos cotidianos.',
	'Preparación para pruebas físicas': 'Rendir al máximo en evaluaciones.',
	'Recuperación postparto': 'Volver a la forma física segura.',
	'Prevención de lesiones': 'Reducir riesgos durante el ejercicio.',
	'Adaptación para principiantes': 'Introducirse al entrenamiento.',
	'Entrenamiento para tercera edad': 'Mantener movilidad y fuerza.',
	'Mejora de agilidad': 'Optimizar velocidad de reacción.',
	'Entrenamiento de equilibrio': 'Aumentar estabilidad corporal.',
	'Primeros pasos en el fitness': 'Iniciar actividad física de forma segura.',
	'Aprender técnica básica': 'Dominar ejercicios fundamentales.',
	'Rutina fácil en casa': 'Entrenar sin necesidad de gimnasio.',
	'Incremento progresivo': 'Aumentar carga de forma gradual.',
	'Pérdida de peso suave': 'Reducir peso sin presión.',
	'Mejora de coordinación': 'Sincronizar movimientos y control.',
	'Entrenamiento de bajo impacto': 'Ejercitar sin sobrecargar articulaciones.',
	'Introducción al cardio': 'Mejorar salud cardiovascular.',
	'Hábitos saludables iniciales': 'Adoptar rutinas de bienestar.',
	'Confianza en el entrenamiento': 'Sentirse seguro al ejercitarse.',
	'Recuperación muscular avanzada': 'Terapias y rutinas post-entrenamiento.',
	'Fortalecimiento articular': 'Proteger y mejorar articulaciones.',
	'Rehabilitación deportiva': 'Recuperarse de lesiones deportivas.',
	'Prevención de recaídas': 'Evitar nuevas lesiones.',
	'Plan antiinflamatorio': 'Reducir inflamación mediante alimentación.',
	'Alimentación para alto rendimiento': 'Nutrición para atletas.',
	'Suplemetación personalizada': 'Optimizar rendimiento con suplementos.',
	'Control hormonal deportivo': 'Equilibrar hormonas para el entrenamiento.',
	'Optimización metabólica': 'Mejorar quema de energía y eficiencia.',
	'Farmacología deportiva segura': 'Uso controlado de ayudas ergogénicas.',
	'Recuperación postcompetencia': 'Restaurar energía tras eventos.',
	'Entrenamiento de fuerza máxima': 'Superar límites de potencia.',
	'Entrenamiento HIIT especializado': 'Cardio intenso para alto nivel.',
	'Plan de resistencia extrema': 'Prepararse para desafíos prolongados.',
	'Mejora de la composición corporal': 'Optimizar músculo y grasa.',
	'Dieta cetogénica': 'Plan bajo en carbohidratos.',
	'Dieta alta en proteínas': 'Enfoque proteico para músculo.',
	'Plan vegano deportivo': 'Nutrición sin origen animal.',
	'Plan para ganancia limpia': 'Aumentar músculo sin exceso de grasa.',
	'Recuperación neuromuscular': 'Mejorar conexión mente-músculo.',
} as const

export default objectivesMap
